import {
  GroupFragment,
  RoleAssignmentFragment,
  UserDetailFragment,
} from '@bmwe/data/kwg/graphql';
import { ROLE_HIERARCHY } from './roleHierarchy';
import { ActiveUser, RoleAssignmentModel } from '../types';

export function getAppRole(
  entity: UserDetailFragment | GroupFragment | null | undefined,
): RoleAssignmentFragment | undefined {
  // Hack: Eventually groups will also have the role assignments
  if (!entity || !('roleAssignments' in entity)) {
    return undefined;
  }
  return entity?.roleAssignments?.nodes?.find(
    (x) => !x.dossierId && !x.objectType,
  );
}

export function getActiveUserAppRole(
  user: ActiveUser | null | undefined,
): RoleAssignmentModel | null {
  const userAppRoles =
    user?.roleAssignments?.filter((x) => !x.dossierId && !x.objectType) ?? [];

  const groupAppRoles =
    user?.groups?.flatMap((g) =>
      g.roleAssignments.filter((x) => !x.dossierId && !x.objectType),
    ) ?? [];

  const allRoles = [...userAppRoles, ...groupAppRoles].sort((a, b) => {
    return ROLE_HIERARCHY[b.roleType] - ROLE_HIERARCHY[a.roleType];
  });

  return allRoles[0] ?? null;
}
